import { render, staticRenderFns } from "./SaveSearch.vue?vue&type=template&id=5af28be2&scoped=true&"
import script from "./SaveSearch.vue?vue&type=script&lang=js&"
export * from "./SaveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af28be2",
  null
  
)

export default component.exports